import { Link } from "react-router-dom";
import Carousel from "react-bootstrap/Carousel";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import LogoFuneraria from "../../assets/logo/logo-funeraria-krause-branco.png";
import ImgFuneraria from "../../assets/images/funeraria-krause.webp";
import LogoMemorial from "../../assets/logo/logo-memorial-krause-branco.png";
import ImgMemorial from "../../assets/images/memorial-krause.webp";
import LogoAssistencial from "../../assets/logo/logo-krause-assistencial-branco.png";
import ImgAssistencialNH from "../../assets/images/assistencial-novo-hamburgo.webp";
import ImgAssistencialEV from "../../assets/images/assistencial-estancia-velha.webp";
import ImgAssistencialCB from "../../assets/images/assistencial-campo-bom.webp";
import ImgAssistencialDI from "../../assets/images/assistencial-dois-irmaos.webp";
import ImgAssistencialIvoti from "../../assets/images/assistencial-ivoti.webp";
import ImgAssistencialSL from "../../assets/images/assistencial-sao-leopoldo.webp";
import ImgAssistencialSP from "../../assets/images/assistencial-sapiranga.webp";
import { GrLocation } from "react-icons/gr";
import "./LocationCall.css";

export default function LocationCall(props) {
  return (
    <Container>
      <Row>
        <Col className="location-call-first-col">
          <GrLocation
            style={{ color: props.iconColor }}
            className="location-call-icon"
          />
          <h2 style={{ color: props.titleColor, fontSize: props.titleSize }}>
            ONDE ESTAMOS
          </h2>
        </Col>
      </Row>
      <Row>
        <Col className="location-call-second-col">
          <p style={{ color: props.textColor, fontSize: props.textSize }}>
            O Grupo Krause conta com a Funerária Krause, Krause Assistencial e
            Cemitério Memorial Krause em Novo Hamburgo e uma rede de filiais da
            Krause Assistencial em várias cidades da região.
          </p>
        </Col>
      </Row>
      <Row>
        <Col className="location-call-col">
          <Link
            className="location-call-link"
            to="/onde-estamos/#funerario"
            style={{ color: props.white }}
          >
            <div className="location-call-card">
              <img
                src={ImgFuneraria}
                alt="funerária"
                className="location-call-img"
              />
              <div
                style={{ background: props.fadeBG }}
                className="location-call-img-overlay"
              >
                <img src={LogoFuneraria} alt="logo funerária" />
                <h2>Novo Hamburgo</h2>
              </div>
            </div>
          </Link>
        </Col>
        <Col className="location-call-col">
          <Link
            className="location-call-link"
            to="/onde-estamos/#cemiterio"
            style={{ color: props.white }}
          >
            <div className="location-call-card">
              <img
                src={ImgMemorial}
                alt="memorial"
                className="location-call-img"
              />
              <div
                style={{ background: props.fadeBG }}
                className="location-call-img-overlay"
              >
                <img src={LogoMemorial} alt="logo memorial" />
                <h2>Novo Hamburgo</h2>
              </div>
            </div>
          </Link>
        </Col>
        <Col className="location-call-col">
          <Link
            className="location-call-link"
            to="/onde-estamos/#assistencial"
            style={{ color: props.white }}
          >
            <Carousel
              controls={false}
              indicators={false}
              interval={3000}
              touch={false}
              pause={false}
              fade
              className="location-call-carousel"
            >
              <Carousel.Item className="location-call-carousel-item">
                <div className="location-call-card">
                  <img
                    src={ImgAssistencialNH}
                    alt="assistencial novo hamburgo"
                    className="location-call-img"
                  />
                  <div
                    style={{ background: props.fadeBG }}
                    className="location-call-img-overlay"
                  >
                    <img src={LogoAssistencial} alt="logo assistencial" />
                    <h2>Novo Hamburgo</h2>
                  </div>
                </div>
              </Carousel.Item>
              <Carousel.Item className="location-call-carousel-item">
                <div className="location-call-card">
                  <img
                    src={ImgAssistencialEV}
                    alt="assistencial estância"
                    className="location-call-img"
                  />
                  <div
                    style={{ background: props.fadeBG }}
                    className="location-call-img-overlay"
                  >
                    <img src={LogoAssistencial} alt="logo assistencial" />
                    <h2>Estância Velha</h2>
                  </div>
                </div>
              </Carousel.Item>
              <Carousel.Item className="location-call-carousel-item">
                <div className="location-call-card">
                  <img
                    src={ImgAssistencialCB}
                    alt="assistencial campo bom"
                    className="location-call-img"
                  />
                  <div
                    style={{ background: props.fadeBG }}
                    className="location-call-img-overlay"
                  >
                    <img src={LogoAssistencial} alt="logo assistencial" />
                    <h2>Campo Bom</h2>
                  </div>
                </div>
              </Carousel.Item>
              <Carousel.Item className="location-call-carousel-item">
                <div className="location-call-card">
                  <img
                    src={ImgAssistencialDI}
                    alt="assistencial dois irmãos"
                    className="location-call-img"
                  />
                  <div
                    style={{ background: props.fadeBG }}
                    className="location-call-img-overlay"
                  >
                    <img src={LogoAssistencial} alt="logo assistencial" />
                    <h2>Dois Irmãos</h2>
                  </div>
                </div>
              </Carousel.Item>
              <Carousel.Item className="location-call-carousel-item">
                <div className="location-call-card">
                  <img
                    src={ImgAssistencialIvoti}
                    alt="assistencial ivoti"
                    className="location-call-img"
                  />
                  <div
                    style={{ background: props.fadeBG }}
                    className="location-call-img-overlay"
                  >
                    <img src={LogoAssistencial} alt="logo assistencial" />
                    <h2>Ivoti</h2>
                  </div>
                </div>
              </Carousel.Item>
              <Carousel.Item className="location-call-carousel-item">
                <div className="location-call-card">
                  <img
                    src={ImgAssistencialSL}
                    alt="assistencial sao leopoldo"
                    className="location-call-img"
                  />
                  <div
                    style={{ background: props.fadeBG }}
                    className="location-call-img-overlay"
                  >
                    <img src={LogoAssistencial} alt="logo assistencial" />
                    <h2>São Leopoldo</h2>
                  </div>
                </div>
              </Carousel.Item>
              <Carousel.Item className="location-call-carousel-item">
                <div className="location-call-card">
                  <img
                    src={ImgAssistencialSP}
                    alt="assistencial sapiranga"
                    className="location-call-img"
                  />
                  <div
                    style={{ background: props.fadeBG }}
                    className="location-call-img-overlay"
                  >
                    <img src={LogoAssistencial} alt="logo assistencial" />
                    <h2>Sapiranga</h2>
                  </div>
                </div>
              </Carousel.Item>
            </Carousel>
          </Link>
        </Col>
      </Row>
    </Container>
  );
}
